module.exports = __webpack_public_path__ + "img/circle_stamp.7f8b9ad0.png";